import React, { useState, useContext } from 'react';
import { CurpContext } from '../context/CurpContext';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import BackgroundLayout from '../components/BackgroundLayout';
import { toast } from 'react-hot-toast';

const Vaccine = () => {
    const navigate = useNavigate();
    const { curp } = useContext(CurpContext);
    const inputClass = "border p-2 rounded-md w-full drop-shadow-md mt-5";

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    };

    const [formData, setFormData] = useState({
        curp: curp,
        vaccine_category: '',
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://admin-django-inspira.azurewebsites.net/api/services/register-vaccine-user/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            if (response.ok) {
                toast.success('Unas preguntitas antes de agendar 🤓')
                navigate('/services/vaccine/medical-record'); // Redirige a una página de éxito
            } else {
                toast.error('Ay, algo pasó, intenta nuevamente.');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Aumenta el tiempo entre la aparición de cada hijo
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 2,
            y: 0,
            transition: {
                duration: 1, // Aumenta la duración de la animación
                ease: "easeInOut", // Suaviza la animación
            },
        },
        exit: {
            opacity: 0,
            y: 20,
            transition: {
                duration: 1, // Aumenta la duración de la animación de salida
                ease: "easeInOut", // Suaviza la animación de salida
            },
        },
    };

    return (
        <BackgroundLayout className="px-8 pb-24">
            <motion.div
                className="w-full text-left mt-0 lg:w-2/3 lg:mb-10"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <Logo />
                <motion.h1 initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.5 }} className='text-5xl font-bold text-[#f8485e] mt-10 uppercase drop-shadow-sm'>Elige tu poción mágica 💉</motion.h1>
                <motion.h1 variants={itemVariants} className="text-base text-justify font-bold mt-5 mb-5 text-gray-800 uppercase drop-shadow-sm">Selecciona la vacuna de tu interés</motion.h1>
                <form onSubmit={handleSubmit}>
                    <motion.div className="mb-4" variants={itemVariants}>
                        <select
                            name="vaccine_category"
                            value={formData.vaccine_category}
                            onChange={handleChange}
                            className={inputClass}
                            required
                        >
                            <option value="">Selecciona</option>
                            <option value="0">VPH - Gardasil 4 (Tetravalente)</option>
                            <option value="1">VPH - Gardasil 9 (Nonavalente)</option>
                            <option value="2">Herpes Zóster</option>
                            <option value="3">Hepatitis B</option>
                        </select>
                    </motion.div>
                    <motion.div variants={itemVariants} className='w-full flex justify-center'>
                        <button type="submit" className="bg-[#f8485e] hover:bg-[#d93a4f] text-white mt-10 mb-24 p-4 rounded-xl shadow-lg w-1/2 text-lg font-bold uppercase transition-all active:scale-95">
                            Enviar
                        </button>
                    </motion.div>
                </form>
            </motion.div>
        </BackgroundLayout>
    );
};

export default Vaccine;